<template>
    <div v-if="payMethodModal.isVisible">
        <div class="overlay" v-if="payMethodModal.buttons.length > 1"></div>
        <div class="overlay" v-else @click="handleButtonAction(payMethodModal.buttons[0].buttonAction)"></div>
        <div class="modal-container">
            <div class="modal-title">
                <i :class="payMethodModal.icon"></i>
            </div>
            <div class="modal-body">{{ payMethodModal.text }}</div>

            <div class="payment-methods">
                <template v-for="(method, key) in payMethodModal.paymentMethods">
                    <div class="payment-method" :key="key" v-if="method.show">
                        <input type="radio" :id="method.id" :name="payMethodModal.name" :value="method.id" v-model="selectedMethod">
                        <label :for="method.id">
                            <h1 v-text="method.name"></h1>
                        </label>
                    </div>
                </template>
            </div>

            <div class="modal-footer">
                <button v-for="(btn, btnkey) in payMethodModal.buttons" :key="btnkey" @click="navigateToPayment()" v-text="btn.buttonText"></button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'PaymentMethodModal',
    components: {},
    data () {
        return {
            selectedMethod: ''
        }
    },
    computed: {
        ...mapGetters(['payMethodModal'])
    },
    methods: {
        ...mapActions(['closePayMethodModal', 'setRechargeMode']),
        handleButtonAction: function (btnAction) {
            if (btnAction) {
                this.$emit(btnAction)
            }
            this.closePayMethodModal()
        },
        navigateToPayment: function () {
            if (this.selectedMethod === '') {
                return
            }
            if (this.selectedMethod === 1) {
                this.setRechargeMode('credit')
                this.$router.push('/cardRecharge/cardPayment')
            } else if (this.selectedMethod === 2) {
                this.setRechargeMode('pix')
                this.$router.push('/cardRecharge/pixPayment')
            }
        }
    }
}
</script>

<style lang="less" scoped>
.modal-container {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto 30px;
    border-radius: 10px;
    z-index: 2;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    background-color: var(--backgroundColor);
    height: max-content;
    .modal-title {
        display: flex;
        margin-top: 10px;
        align-items: flex-end;
        justify-content: center;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        font-size: 2rem;
    }
    .modal-body {
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        margin-top: 20px;
        margin-bottom: 10px;
        padding: 0 10px;
    }

    .payment-methods {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        input[type="radio"] {
          accent-color: var(--buttonBackground);
          cursor: pointer;
        }

        .payment-method {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
            margin-bottom: 10px;
            input {
                margin-right: 10px;

                &:checked {
                    &::after {
                        position: relative;
                        width: 15px;
                        height: 15px;
                        border-radius: 15px;
                        top: -2px;
                        left: -1px;
                        background-color: var(--primaryColor);
                        content: '';
                        display: inline-block;
                        visibility: visible;
                        border: 2px solid white;
                    }
                }
            }
        }
    }
    .modal-footer {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        margin-bottom: 10px;
        margin-top: 20px;
        button {
            color: var(--buttonText);
            background: var(--buttonBackground);
            padding: 5px 10px;
            border: none;
            border-radius: 5px;
            font-size: 1rem;
            min-width: 90px;
        }
    }
}
.overlay {
        position: fixed;
        top: 0; left: 0;
        height: 100vh;
        width: 100vw;
        overflow: hidden;
        background: var(--backgroundColorOverlay);
    }
</style>
